import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, value, unit, icon, iconColor, subtitle }) => {
  return (
    <div className="rounded-2xl border border-border/80 bg-card p-4 shadow-sm transition-shadow hover:shadow-md md:p-5">
      <div className="flex items-start gap-3">
        <div
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl md:h-11 md:w-11"
          style={{ backgroundColor: `${iconColor}18` }}
        >
          <Icon name={icon} size={20} color={iconColor} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-medium text-muted-foreground">{title}</p>
          <p className="mt-0.5 text-xl font-semibold tabular-nums tracking-tight text-foreground md:text-2xl">
            {value}
            {unit ? (
              <span className="ml-1 text-sm font-normal text-muted-foreground">{unit}</span>
            ) : null}
          </p>
          {subtitle ? (
            <p className="mt-1 text-xs text-muted-foreground">{subtitle}</p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MetricsCard;
